/* eslint-disable import/no-cycle */

import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const getMerchantListApi = (data) => DataService.get(`/merchants?${getQueryString(data)}`);
export const getMerchantDetailsApi = (id) => DataService.get(`/merchant/${id}`);
export const updateMerchantStatusApi = (merchantId, payload) =>
  DataService.put(`/merchant/${merchantId}/status`, payload);
export const resendApprovedNotificationToMerchantApi = (merchantId) =>
  DataService.post(`/merchant/${merchantId}/resend-approved-notification-to-merchant`);
